export const SIDEBAR_WIDTH_EXPANDED_PX = 300;
export const SIDEBAR_WIDTH_COMPACT_EXPANDED_PX = 220;
export const SIDEBAR_WIDTH_COLLAPSED_PX = 72;
export const FACILITATOR_SIDEBAR_WIDTH_EXPANDED_PX = 260;
export const FACILITATOR_SIDEBAR_WIDTH_COMPACT_EXPANDED_PX = 200;
export const ADMIN_SIDEBAR_WIDTH_EXPANDED_PX = 260;
export const ADMIN_SIDEBAR_WIDTH_COMPACT_EXPANDED_PX = 220;

export type SidebarLayoutMode = "collapsed" | "compact-expanded" | "full-expanded";
export type SidebarLayoutVariant = "company" | "role" | "admin";

export function resolveSidebarWidthPx(
  mode: SidebarLayoutMode,
  variant: SidebarLayoutVariant,
): number {
  if (mode === "collapsed") return SIDEBAR_WIDTH_COLLAPSED_PX;
  if (variant === "company") {
    return mode === "full-expanded"
      ? SIDEBAR_WIDTH_EXPANDED_PX
      : SIDEBAR_WIDTH_COMPACT_EXPANDED_PX;
  }
  if (variant === "admin") {
    return mode === "full-expanded"
      ? ADMIN_SIDEBAR_WIDTH_EXPANDED_PX
      : ADMIN_SIDEBAR_WIDTH_COMPACT_EXPANDED_PX;
  }
  return mode === "full-expanded"
    ? FACILITATOR_SIDEBAR_WIDTH_EXPANDED_PX
    : FACILITATOR_SIDEBAR_WIDTH_COMPACT_EXPANDED_PX;
}
export const SIDEBAR_ACTIVE_HIGHLIGHT = "#ffc300";

// Portal shell sidebar theming (role-specific)
export const FACILITATOR_SIDEBAR_BG = "#2E7D32";
export const EXPERT_SIDEBAR_BG = "#C65D00";
export const ECOSYSTEM_HEAD_SIDEBAR_BG = "#7A1F2B";
export const EXPO_HEAD_SIDEBAR_BG = "#0F4C5C";

export const PORTAL_SHELL_COLORS = {
  FACILITATOR: FACILITATOR_SIDEBAR_BG,
  EXPERT: EXPERT_SIDEBAR_BG,
  ECOSYSTEM_HEAD: ECOSYSTEM_HEAD_SIDEBAR_BG,
  ECOSYSTEM_SUBHEAD: ECOSYSTEM_HEAD_SIDEBAR_BG,
  EXPO_HEAD: EXPO_HEAD_SIDEBAR_BG,
} as const;

export const SIDEBAR_GRIDLINE_OVERLAY =
  "repeating-linear-gradient(0deg, rgba(255,255,255,0.06) 0, rgba(255,255,255,0.06) 1px, transparent 1px, transparent 40px), repeating-linear-gradient(90deg, rgba(255,255,255,0.06) 0, rgba(255,255,255,0.06) 1px, transparent 1px, transparent 40px)";

/** Facilitator / ecosystem-head sidebar profile logo (expanded rail). */
export const SIDEBAR_PROFILE_LOGO_EXPANDED_MAX_HEIGHT_PX = 160;
export const SIDEBAR_PROFILE_LOGO_COLLAPSED_SIZE_PX = 56;
